import { IValidationGroup } from '../../../../../hooks/validation-group/validation-group-hook';
import { FormFieldLine } from '../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../components/inputs/input/input';
import { NOTE_TYPE, Note } from '../../../../../components/note/note';

interface IProps {
    value: string;
    onChange: (value: string) => void,
    validationGroup: IValidationGroup,
    disabled?: boolean,
    name: string,
    isShipping?: boolean
}

const ConnectionNameField: React.FC<IProps> = ({ value, onChange, validationGroup, disabled, name, isShipping = false }) => (
    <>
        <FormFieldLine
            required
            label='Connection name'
            key='connection-name'
            note={`Name the connection so you will easily identify it if you have multiple connections to ${name}.`}
        >
            <Input
                value={value}
                onChange={onChange}
                validationGroup={validationGroup}
                autoComplete='connection-name'
                required
                disabled={disabled}
            />
        </FormFieldLine>
        {isShipping && <Note
            type={NOTE_TYPE.INFORMATION}
            body={<>You will be able to use this connection in different Return Methods.
                In each Return Method, you will be able to configure the labels that will be generated by this connection to suit the Return Method’s purposes.</>}
        />}
    </>
);

export default ConnectionNameField;
